// Runtime env accessor.
//
// CRA bakes `process.env.REACT_APP_*` at BUILD time, so a single image cannot be
// configured per environment. The BFF (server/index.js) injects a `window.__ENV__`
// object at page-serve time from flat (non-REACT_APP_) container env vars.
//
// Resolution order for a key K:
//   1. window.__ENV__[K]                 (runtime, injected by the BFF)
//   2. process.env['REACT_APP_' + K]     (build-time fallback, local `npm start`)
//   3. provided default `d`
//
// Only PUBLIC values ever flow through here — never a secret.
export const env = (k, d) =>
    (typeof window !== 'undefined' && window.__ENV__ && window.__ENV__[k]) ||
    process.env['REACT_APP_' + k] ||
    d;

export default env;
